import { useCallback, useMemo } from "react";
import { useLocation, useNavigate } from "react-router";

import Box from "@mui/material/Box";
import { Modal } from "@covertree/ui";
import { FastUWRejection } from "@covertree/new-business-fast-uw-rejection";
import {
  selectPolicyErrorState,
  setPolicyErrorState,
  useNewBusinessSelector,
} from "@covertree/new-business-redux";
import { RedZoneErrorType } from "@covertree/types";

import { useAppDispatch } from "@redux/hooks";
import { OVERVIEW_PATH } from "@routing/paths";

function CYQRedZoneErrorModal() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const location = useLocation();
  const riskError = useNewBusinessSelector(selectPolicyErrorState) as {
    errorType?: RedZoneErrorType;
  };

  const errorMessage = useMemo(() => location.state?.errorMessage, [location]);

  const handleCloseModal = useCallback(() => {
    if (location.state?.previousPath) {
      navigate(location.state?.previousPath);
    } else {
      navigate(`/${OVERVIEW_PATH}`);
    }
    dispatch(setPolicyErrorState(undefined));
  }, [location, navigate]);

  if (!riskError) return;

  return (
    <Modal open={!!riskError} onClose={handleCloseModal} maxWidth="md">
      <Box p={2}>
        <FastUWRejection
          icon={"/images/decline-property/decline-property.webp"}
          errorType={riskError?.errorType}
          errorMessage={errorMessage}
          showLegalText
        />
      </Box>
    </Modal>
  );
}

export { CYQRedZoneErrorModal };
